import { z } from './utils/zod.js';
import { dataResponse } from './utils/response-templates.js';
import { listSigningsDtoSchema } from './signings.js';
export const pendingSigningSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    createdAt: z.string().datetime(),
    expirationDate: z.string().datetime().nullable(),
});
// allowed and available are absent when the plan has no member limit.
export const teamMembersUsageSchema = z.object({
    current: z.number(),
    allowed: z.number().optional(),
    available: z.number().optional(),
});
export const userActivityDataSchema = z.object({
    teamMembers: z.optional(teamMembersUsageSchema),
    pendingSignings: z.array(listSigningsDtoSchema),
    finishedSignings: z.array(listSigningsDtoSchema),
});
export const userActivityResponseSchema = dataResponse(userActivityDataSchema);
